import { addMilliseconds, addMinutes } from 'date-fns';
import type { Schedules } from '@studio/types';
import { getPreEventBuffer } from '../getPreEventBuffer';

const getEncoderScheduleTimeRange = ({
  contentScheduleLocalStartTime,
  encoderSchedule,
  eventStartDateTime,
}: {
  contentScheduleLocalStartTime?: string;
  encoderSchedule?: Schedules.Get.EncoderSchedule;
  eventStartDateTime?: Date;
}): { end: Date; start: Date } | undefined => {
  if (!eventStartDateTime || !encoderSchedule?.durationMillis) return undefined;
  const preEventBuffer = getPreEventBuffer(encoderSchedule.localStartTime, contentScheduleLocalStartTime);
  const durationMillis = encoderSchedule.durationMillis;
  const start = addMinutes(eventStartDateTime, -preEventBuffer);
  const end = addMilliseconds(start, durationMillis);
  return { start, end };
};

export default getEncoderScheduleTimeRange;
